import React, { FC } from 'react';
import cls from 'classnames';
import { GridListProps } from './types';
import './index.scss';

export function initArray(n: number) {
  const arr = [];
  for (let i = 0; i < n; i++) {
    arr.push(i);
  }
  return arr;
}

export default ({
  CnBox,
  coefficient,
  unit,
}: {
  CnBox: FC<any>;
  coefficient: number;
  unit: string;
}) => {
  return function GridList<TData = unknown>({
    dataSource = [],
    layoutConfig = {
      type: 'flex',
      columnGap: 16,
      rowGap: 8,
    },
    renderItem,
    divider,
  }: GridListProps<TData>) {
    const { length } = dataSource;

    const { columnGap = 8, rowGap = 0, columns = 4, type } = layoutConfig;

    const rowCount = Math.ceil(length / columns);
    const rows = initArray(rowCount);
    if (type === 'flex') {
      return (
        <div
          className="grid-list-flex-wrap"
          style={{
            flexGrow: 1,
            display: 'flex',
            flexWrap: 'wrap',
            margin: `-${(rowGap / 2) * coefficient}${unit} -${
              (columnGap / 2) * coefficient
            }${unit}`,
          }}
        >
          {dataSource.map((item, index) => {
            return (
              <div
                key={index}
                className={cls({
                  'grid-list-divider': divider,
                })}
                style={{
                  flexGrow: 0,
                  margin: `${(rowGap / 2) * coefficient}${unit} ${
                    (columnGap / 2) * coefficient
                  }${unit}`,
                }}
              >
                {renderItem?.(item, index)}
                {divider && index !== length - 1 ? (
                  <span
                    className="grid-list-divider-line"
                    style={{ right: `-${(columnGap / 2) * coefficient}${unit}` }}
                  />
                ) : null}
              </div>
            );
          })}
        </div>
      );
    }

    if (type === 'grid') {
      return (
        <div
          className="grid-list-grid-wrap"
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
            gridColumnGap: `${columnGap * coefficient}${unit}`,
            gridRowGap: `${rowGap * coefficient}${unit}`,
          }}
        >
          {dataSource.map((item, index) => renderItem?.(item, index))}
        </div>
      );
    }

    return (
      <div style={{ width: '100%', flexGrow: 1 }}>
        <CnBox spacing={rowGap} direction="column">
          {rows.map((index) => {
            return (
              <CnBox spacing={columnGap} direction="row" key={index} style={{ overflow: 'auto' }}>
                {dataSource
                  .filter((item, idx) => idx >= index * columns && idx < index * columns + columns)
                  .map((item, idx) => {
                    return (
                      <div
                        key={idx}
                        style={{
                          flexGrow: 0,
                          width: `calc((100% - ${columnGap}*var(--m-s-base, ${coefficient}${unit})*${
                            columns - 1
                          })/${columns})`,
                        }}
                      >
                        {renderItem?.(item, index)}
                      </div>
                    );
                  })}
              </CnBox>
            );
          })}
        </CnBox>
      </div>
    );
  };
};
